/**
 * created by wang lei
 表格前插入行 页面
 *
 */
import React, {Component} from 'react';
import tableBeforeInsertRow from './tableBeforeInsertRow.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class TableBeforeInsertRowTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableBeforeInsertRow:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let tableBeforeInsertRow = this.props.editor.queryCommandState('deleteTable')
        this.setState({tableBeforeInsertRow: tableBeforeInsertRow === 0});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let tableBeforeInsertRow = this.props.editor.queryCommandState('deleteTable')
        this.setState({tableBeforeInsertRow: tableBeforeInsertRow === 0});
    }
    render() {
        return (
            <span style={{cursor:"pointer",opacity:this.state.tableBeforeInsertRow ? "1":"0.3"}}>
                <img className={"editor-tableBeforeInsertRow-tool-btn"} src={tableBeforeInsertRow} onClick={()=>this.props.editor.execCommand("insertparagraphbeforetable")}/>
                {this.state.tableBeforeInsertRow ?
                    <style>{`
                .editor-tableBeforeInsertRow-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-tableBeforeInsertRow-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-tableBeforeInsertRow-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style> :  <style>{`
                .editor-tableBeforeInsertRow-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-tableBeforeInsertRow-tool-btn:hover{
                    border: 1px solid transparent
                }
                .editor-tableBeforeInsertRow-tool-btn:active{
                    border: 1px solid transparent
                }
            `}</style>
                }

            </span>
        )
    }

}